import "./App.css";
import Map from "./routes/map/map.component";

import { Routes, Route } from "react-router-dom";
import HeaderApp from "./components/header-app/header-app.component";
import District from "./routes/distric/district.component";
import FooterApp from "./components/footer-app/footer-app.component";
import React, { Component } from "react";

const App = () => {
  return (
      <Routes>
        <Route path="/" element={<HeaderApp />}>

          <Route index element={<Map />} />
          <Route path="/index.html" element={<Map />} />
          <Route path="district" element={<District />} />
          <Route path="district/:state/:districtId/:lodgeId" element={<District />} />

          <Route exact path="/" element={<FooterApp />} />
        </Route>
      </Routes>
  );
};

export default App;
